import React from 'react';
import { Link } from 'react-router-dom';
import { AUTHOR } from './author';

// Signature sous le titre d'un guide : photo, nom (vers la page autrice), date et temps de lecture
export const AuthorByline: React.FC<{ updatedLabel: string; readingMinutes: number }> = ({
  updatedLabel,
  readingMinutes,
}) => (
  <div className="mg-byline">
    <img className="mg-avatar" src={AUTHOR.avatar} alt="" width={40} height={40} />
    <p className="mg-article-meta">
      Par <Link to={AUTHOR.path}>{AUTHOR.name}</Link>
      <br />
      Mis à jour le {updatedLabel} · {readingMinutes} min de lecture
    </p>
  </div>
);

// Encadré « À propos de l'autrice » en fin de guide
export const AuthorBox: React.FC = () => (
  <aside className="mg-author-box" aria-label="À propos de l’autrice">
    <img className="mg-avatar mg-avatar-lg" src={AUTHOR.avatar} alt="" width={64} height={64} loading="lazy" />
    <div className="mg-author-id">
      <p className="mg-author-name">
        <Link to={AUTHOR.path}>{AUTHOR.name}</Link>
      </p>
      <p className="mg-author-role">{AUTHOR.role}</p>
    </div>
    <p className="mg-author-bio">{AUTHOR.short}</p>
  </aside>
);
